export const getOrderVat = (order: GQL.IOrder) => {
  if (order && order.orderedItems) {
    return order.orderedItems.reduce((acc: number, item: GQL.IOrderItem) => {
      if (item.VATrate && item.VATrate > acc) {
        acc = item.VATrate;
      }
      return acc;
    }, 0);
  }

  return 0;
};


// WEBPACK FOOTER //
// ./src/helpers/orders/getOrderVat.ts